export default __webpack_public_path__ + "1041f1606415e0d05a2c11174f14117a.svg";